import { Price, SubscriptionPeriod } from '../../../models/Article';
import { http } from '../axios';
import { shopPrefix } from '../../config';

const FETCH_SUBSCRIPTION_PERIOD_PRICES_URL = `${shopPrefix}/v2/products/:productId/subscription-periods`;

export type SubscriptionPeriodPricesOut = { subscriptionPeriod: SubscriptionPeriod; availablePrices: Price[] };

export type SubscriptionPeriodPricesContainerOut = {
    renewalDate: string;
    currentPeriod: SubscriptionPeriodPricesOut;
    nextPeriod: SubscriptionPeriodPricesOut;
};

export const fetchProductSubscriptionPeriodsV2 = (productId: string) => {
    return http
        .get<SubscriptionPeriodPricesContainerOut>(FETCH_SUBSCRIPTION_PERIOD_PRICES_URL, {
            pathParams: { productId }
        })
        .then(res => res.data);
};
